import { computed } from 'vue'
import { dt       } from '@sumdoo/shared'

export const useDatePrefix = (props: { date: Date }) => {
     // 上月前缀
    const prevMonthDatePrefix$ = computed(() => {
        const date = props.date
        const y = dt.getYear(date)
        const m = dt.getMonth(date)
        const d = dt.newDate(y, m, 0)
        
        return dt.format(d, 'YYYY-MM')
    })

    // 当月前缀
    const curMonthDatePrefix$ = computed(() => {
        return dt.format(props.date, 'YYYY-MM')
    })

    // 下月前缀
    const nextMonthDatePrefix$ = computed(() => {
        const date = props.date
        const y = dt.getYear(date)
        const m = dt.getMonth(date) + 1
        const d = dt.newDate(y, m, 1)
        
        return dt.format(d, 'YYYY-MM')
    })

    return {
        prevMonthDatePrefix$,
        curMonthDatePrefix$,
        nextMonthDatePrefix$ 
    }
}
